<template>
  <div class="container">
    <RoomProvider></RoomProvider>
    <BookingProvider :date="date"></BookingProvider>
    <div v-if="isOwner">
      <div class="toolbar">
        <GoBackButton class="back-button"></GoBackButton>
        <h2>Muokkaa varausta</h2>
      </div>
      <div v-if="doneLoading">
        <BookingEditForm :booking="booking" @change="onChange()"></BookingEditForm>
        <button class="btn" @click="onSave()">Tallenna</button>
        <div v-if="saving">Tallennetaan...</div>
        <div class="delete">
          <button class="btn btn-flat" @click="onDelete()">Poista varaus</button>
          <div v-if="deleting">Poistetaan...</div>
        </div>
      </div>
      <div v-else>
        Ladataan...
      </div>
    </div>
    <div v-else>
      <div class="toolbar">
        <GoBackButton class="back-button"></GoBackButton>
        <h2>Varaus</h2>
      </div>
      <div v-if="doneLoading">
        <h3>{{room.name}}</h3>
        <BookingInfoDisplay :booking="booking"></BookingInfoDisplay>
      </div>
    </div>
    <ConfirmToast
      v-if="confirmingDelete"
      @confirm="confirmDelete()"
      @cancel="cancelDelete()"
      question="Poistetaanko varaus?"
      confirmText="Poista"
      cancelText="Älä poista"
      >
    </ConfirmToast>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RoomProvider from '@/components/providers/RoomProvider'
import BookingProvider from '@/components/providers/BookingProvider'
import BookingEditForm from '@/components/BookingEditForm'
import BookingInfoDisplay from '@/components/BookingInfoDisplay'
import ConfirmToast from '@/components/ConfirmToast'
import GoBackButton from '@/components/GoBackButton'
import TimeUtils from './../utils/TimeUtils'

import { getClaim, isAdmin } from './../utils/cognito';

import Booking from './../store/modules/booking/types'

export default {
  name: 'BookingEditView',
  components: { RoomProvider, BookingProvider, BookingEditForm, BookingInfoDisplay, GoBackButton, ConfirmToast },
  data () {
    return {
      confirmingDelete: false
    }
  },
  computed: {
    isOwner () {
      const mine = this.booking.email === getClaim('email')
      const admin = isAdmin();
      return mine || admin;
    },
    saving () {
      return this.getEditStatus() === 'pending'
    },
    deleting () {
      return this.getDeleteStatus() === 'pending'
    },
    doneLoading () {
      return this.booking && this.room;
    },
    id () {
      console.log('BookingEditView id', this.$route.params.id);

      return this.$route.params.id;
    },
    date () {
      console.log('BookingEditView date', this.$route.params.date);
      return this.$route.params.date;
    },
    room () {
      console.log('BookingEditView roomId', this.booking.roomId);
      if (this.booking.roomId) {
        return this.getRoomById(this.booking.roomId)
      }
    },
    booking () {
      const b = this.getBooking(this.date, this.id)
      return {...b};
    },
    ...mapGetters('Booking', [
      'getBooking',
      Booking.getters.GET_EDIT_STATUS,
      Booking.getters.GET_DELETE_STATUS
    ]),
    ...mapGetters('Room', ['getRoomById'])
  },
  methods: {
    onSave () {
      this.saveEditedBooking(this.booking).then(() => {
        this.$router.go(-1);
      });
    },
    onDelete () {
      this.confirmingDelete = true;
    },
    cancelDelete () {
      this.confirmingDelete = false;
    },
    confirmDelete () {
      this.deleteBooking(this.booking).then(() => {
        this.$router.go(-1);
      });
    },
    ...mapActions('Booking', [Booking.actions.SAVE_EDITED_BOOKING, Booking.actions.DELETE_BOOKING])
  },
}
</script>

<style lang="scss" scoped>
  @import 'src/color.scss';
  @import 'src/values.scss';

  .container {
    padding: 1em;
  }

  .delete {
    margin-top: 2em;
  }

  .btn {
    border: none;

    transition: $transition-time all;
    &:hover {
      background-color: $secondary-dark;
    }
    &:disabled {
      background-color: $tertiary;
      cursor: default !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BookingEditView.vue